export enum SocketEvent {
	CONNECTION_EVENT = 'connection',
	CLIENT_TEST_EVENT = 'client-test',
	TERMINAL_STATUS_EVENT = 'terminalStatus',
	DEVICE_STATUS = 'deviceStatus',
	ANTARA_UPDATE_REFERENCE_EVENT = 'antara-update-reference',
	ANTARA_UPDATE_RECEIPT_EVENT = 'antara-update-receipt',
	TERMINAL_TABLE_REQUEST = 'terminal-table-request',
	TERMINAL_TABLE_RESPONSE = 'terminal-table-response',
	DRIVE_SCREEN_STATUS = 'drive-screen',
	AUTHENTICATE = 'authenticate',
	DEAUTHENTICATE = 'deauthenticate',
	SEND_EMPLOYEE_NOTIFICATION = 'send-employee-notification',
	LOG = 'log',
	EMPLOYEE_NOTIFICATION = 'employee-notification',
	REGISTER_DEVICE = 'registerDevice',
	DEVICE_CONFIG_CHANGE = 'deviceConfigChange',
	TRACK_EVENT = 'trackEvent',
	ORDER_LOG = 'order',
	PAYMENT_LOG = 'payment',
	INTERACTION_LOG = 'interaction',
	ANALYTICS_EVENT = 'analyticsEvent',
	PING_EVENT = 'ping',
	SCREENSHOT_REQUEST = 'screenshotRequest',
	REBOOT_REQUEST = 'rebootRequest',
	CLICK_REQUEST = 'clickRequest',
}
